export enum Product {
  PA6 = 1,
  PAGRID = 2,
}